module.exports = __webpack_public_path__ + "img/programme9.88dfd038.png";